import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './HomeLayout.resolver';
import HomeLayout from './HomeLayout';

export default async(resolver, { context: RootStoreContext })(HomeLayout);
